import { render, staticRenderFns } from "./CustomerAddressEdit.vue?vue&type=template&id=6c852950"
import script from "./CustomerAddressEdit.vue?vue&type=script&lang=js"
export * from "./CustomerAddressEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddressEdit.vue?vue&type=style&index=0&id=6c852950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports